import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { LitmusFeedListViewComponent } from '../../../../shared/components/litmus-feed-list-view/litmus-feed-list-view.component';
import { VerbatimHomeComponent } from '../../../../shared/components/verbatim-home/verbatim-home.component';
import { WordcloudComponent } from '../wordcloud/wordcloud.component';
@Component({
    selector: 'app-project-inbox-home',
    templateUrl: './project-inbox-home.component.html',
    styleUrls: ['./project-inbox-home.component.scss'],
    imports: [NgIf, NgClass, LitmusFeedListViewComponent, VerbatimHomeComponent, WordcloudComponent, AsyncPipe]
})
export class ProjectInboxHomeComponent implements OnInit {
  activeTab: string | null = 'customer_feedback';
  tabList: any = ['customer_feedback', 'verbatim', 'wordcloud']
  tabVisblity: any = {
    customer_feedback: Helpers.isTabVisible(false, 'inbox', 'customer_feedback'),
    verbatim: Helpers.isTabVisible(false, 'inbox', 'verbatim'),
    wordcloud:true
  }
  queryParams$: Observable<any> = of({});
  constructor(private router: Router, private route: ActivatedRoute, private cdr: ChangeDetectorRef) { }



  ngOnInit(): void {
    this.tabVisblity={
      customer_feedback: Helpers.isTabVisible(false, 'inbox', 'customer_feedback'),
      verbatim: Helpers.isTabVisible(false, 'inbox', 'verbatim'),
      wordcloud:true
    }
    if (!this.tabVisblity.customer_feedback) {
      this.tabList = _.filter(this.tabList, (tab: string) => {
        return tab != 'customer_feedback';
      })
    }
    if (!this.tabVisblity.verbatim) {
      this.tabList = _.filter(this.tabList, (tab: string) => {
        return tab != 'verbatim';
      })
    }
    // Initialize activeTab based on query parameters
    this.route.queryParams.subscribe((params: any) => {
      const defaultTab = (this.tabList.length) ? this.tabList[0] : 'wordcloud';
      let tabName = (this.tabList.indexOf(params['active_tab']) >= 0) ? params['active_tab'] : defaultTab;
      this.toggleTab(tabName)// Default to 'customer_feedback' if no query param
      this.cdr.detectChanges();
    });
  }

  // based on the tab selection it's highlight the active tab and change the page url accordingly
  toggleTab(tab: string): void {
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: tab },
      queryParamsHandling: 'merge'
    });
  }

}
